module.exports = __webpack_public_path__ + "assets/media/lunch.9fc76322.mp3";